import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { SvgIconProps, SxProps, Theme } from '@mui/material';
import { ReactElement } from 'react';

type ExpandChevronProps = SvgIconProps & {
  /** When true the chevron points up (rotated 180°); otherwise it points down. */
  expanded: boolean;
};

// Single, app-wide expand/collapse affordance: one downward chevron that
// animates a 180° rotation instead of swapping ExpandMore/ExpandLess (or
// KeyboardArrowUp/Down). Keeps every manual toggle visually consistent with the
// MUI Accordion expand icon.
function ExpandChevron({
  expanded,
  fontSize = 'small',
  sx,
  ...props
}: ExpandChevronProps): ReactElement {
  const rotationSx: SxProps<Theme> = {
    transition: 'transform 0.2s ease',
    transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
  };

  return (
    <ExpandMoreIcon
      fontSize={fontSize}
      {...props}
      sx={[rotationSx, ...(sx ? (Array.isArray(sx) ? sx : [sx]) : [])]}
    />
  );
}

export default ExpandChevron;
